export default {
  title: 'Seu site profissional em poucos cliques',
  description: `
    O Criador de sites é uma ferramenta fácil e intuitiva,
    com modelos de layout personalizados e banco de imagens.
    <span class="d-block gray--text text--scale500 text-paragraph-2">Gerencie seu site usando o menu ao lado ou comece já a editá-lo.</span>
  `,
  buttonLabel: 'Começar a editar'
}
